import(/* webpackMode: "eager", webpackExports: ["PageSponsors"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/sponsors/__page__/PageSponsors.tsx");
